module.exports = __webpack_public_path__ + "img/banner_1.23138349.jpg";